import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-inactivity-warning-modal',
  templateUrl: './inactivity-warning-modal.component.html',
  styleUrls: ['./inactivity-warning-modal.component.scss'],
  standalone: false
})
export class InactivityWarningModalComponent {
  @Input() visible = false;
  @Input() timeoutMinutes = 2;

  @Output() staySignedIn = new EventEmitter<void>();
  @Output() visibleChange = new EventEmitter<boolean>();

  onStaySignedInClick(): void {
    this.staySignedIn.emit();
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
